var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.qqBtn}},[_vm._v("點擊進入Q群:157841427")]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.disBtn}},[_vm._v("點擊進入Discord群")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }